import React from 'react';
import './Logo.css';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
  className?: string;
  logoName?: string;
}

export const Logo: React.FC<LogoProps> = ({ 
  size = 'medium', 
  showText = false,
  className = '',
  logoName = 'logo.png'
}) => {
  return (
    <div className={`logo-container ${size} ${className}`}>
      <img 
        src={`/${logoName}`}
        alt="Ghi Connect Logo" 
        className="logo-image"
      />
      {showText && (
        <div className="logo-text">
          <span className="logo-text-ghi">Ghi</span>
          <span className="logo-text-connect">Connect</span>
        </div>
      )}
    </div>
  );
};
